__turbopack_context__.v({
  "inner": "RestaurantQuickFilter-module-sass-module__-7sGdq__inner",
  "slider": "RestaurantQuickFilter-module-sass-module__-7sGdq__slider",
  "sliderControls": "RestaurantQuickFilter-module-sass-module__-7sGdq__sliderControls",
  "wrapper-skeleton": "RestaurantQuickFilter-module-sass-module__-7sGdq__wrapper-skeleton",
});
